import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  collapsed: false,
};

const siderSlice = createSlice({
  name: "sider",
  initialState,
  reducers: {
    toggleCollapsed: (state) => {
      state.collapsed = !state.collapsed;
    },
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
    },
  },
});

export const { toggleCollapsed, setCollapsed, collapsed } = siderSlice.actions;

export default siderSlice.reducer;
